import * as React from 'react'

import { AppBarHeightPixel } from 'components/simulation-new/components/appbar'
import SidebarDrawer from 'components/shared/sidebar-drawer'
import MobileSidebarDrawer from 'components/shared/mobile-sidebar-drawer'
import { cn } from 'lib/utils'

interface LayoutProps extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactElement | React.ReactElement[]
    showHeader?: boolean
    showFooter?: boolean
    navbar?: JSX.Element
    sidebarContent?: JSX.Element
    openMobileMenu: boolean
    style?: React.CSSProperties
    setMobileMenuOpen: (state: boolean) => void
}

const SideBarLayout = React.memo<LayoutProps>(
    ({ children, navbar, sidebarContent, openMobileMenu, setMobileMenuOpen, ...props }) => {
        return (
            <div className={cn(props.className)}>
                <MobileSidebarDrawer
                    setOpen={setMobileMenuOpen}
                    haveNavbar={!!navbar}
                    sidebarContent={sidebarContent}
                    open={openMobileMenu}
                />
                <div className={cn('flex w-screen h-screen overflow-hidden', { 'blur grayscale': openMobileMenu })}>
                    <SidebarDrawer haveNavbar={!!navbar} sidebarContent={sidebarContent} />
                    {navbar}
                    <div
                        style={{ paddingTop: navbar ? `${AppBarHeightPixel}px` : 0 }}
                        className={cn('pt-4 overflow-auto blur-none flex-1')}>
                        {children}
                    </div>
                </div>
            </div>
        )
    },
)

export default SideBarLayout
